import React from 'react';
import { KakarikoProgress } from '../Progress';
import { StyledButton } from './styles';
import type { IKakarikoButtonProps } from './types';

const circularLoaderSize = 24;

export const KakarikoButton = (props: IKakarikoButtonProps) => {
  const {
    children,
    disabled = false,
    disabledReason = 'Action is disabled',
    handleClick,
    styles,
    isLoading,
    buttonTheme = 'primary',
    buttonRole = 'primary',
    buttonType = 'button',
    buttonSize = 'medium',
  } = props;

  const roleToClassName = {
    primary: '',
    secondary: 'outline',
    link: 'link',
  };

  return (
    <StyledButton
        aria-label={disabled ? disabledReason : ''}
        style={styles}
        onClick={(e: unknown) => handleClick && handleClick(e)}
        disabled={disabled}
        focusRipple
        tabIndex={0}
        type={buttonType}
        className={roleToClassName[buttonRole]}
        $buttonTheme={buttonTheme}
        $buttonSize={buttonSize}
      >
        {children}
        {isLoading && <KakarikoProgress size={circularLoaderSize} />}
      </StyledButton>
  );
};

export const KakarikoButtonFull = (props: IKakarikoButtonProps) => {
  return KakarikoButton({
    ...props,
    buttonSize: 'full',
    buttonTheme: props.buttonTheme || 'default',
    buttonRole: props.buttonRole || 'primary',
  });
};

export const KakarikoButtonLarge = (props: IKakarikoButtonProps) => {
  return KakarikoButton({
    ...props,
    buttonSize: 'large',
    buttonTheme: props.buttonTheme || 'default',
    buttonRole: props.buttonRole || 'primary',
  });
};

export const KakarikoButtonMedium = (props: IKakarikoButtonProps) => {
  return KakarikoButton({
    ...props,
    buttonSize: 'medium',
    buttonTheme: props.buttonTheme || 'default',
    buttonRole: props.buttonRole || 'primary',
  });
};

export const KakarikoButtonSmall = (props: IKakarikoButtonProps) => {
  return KakarikoButton({
    ...props,
    buttonSize: 'small',
    buttonTheme: props.buttonTheme || 'default',
    buttonRole: props.buttonRole || 'primary',
  });
};

export default KakarikoButton;
